import { useMutation, useQueryClient } from '@tanstack/react-query';

import { linkImagesWithMenuItem } from 'apis/mips/api';

import { PhotoShootQueryKeys } from '../constants/queryKeys';

export type UseLinkImageMutationProps = {
  venueId: string;
  token: string | null;
};

type HandleLinkImageProps = { itemId: string; imageIds: string[] };

export const useLinkImageMutation = ({ venueId, token }: UseLinkImageMutationProps) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ itemId, imageIds }: HandleLinkImageProps) => linkImagesWithMenuItem(venueId, itemId, imageIds, token),
    {
      onSuccess: res => queryClient.setQueryData(PhotoShootQueryKeys.GET_PHOTO_SHOOT(venueId, token), res.data),
    },
  );
};
